export const RIGHT_REGISTERS = [131002, 131001, 131004, 131003, 131006, 131005];
export const RIGHT_REGISTERS_DIAGNOSES = [131002, 131001];
export const RIGHT_REGISTERS_HEALTH_FACILITIES = [131004, 131003];
export const RIGHT_REGISTERS_LOCATIONS = [131006, 131005];
export const RIGHT_EXTRACTS = [131101, 131102, 131103, 131104, 131105, 131106];
export const RIGHT_REPORTS = [
  131201, 131202, 131203, 131204, 131205, 131206, 131207, 131208, 131209, 131210, 131211, 131212, 131213, 131214,
  131215, 131216, 131217, 131218, 131219, 131220, 131221, 131222, 131223,
];
export const RIGHT_UTILITIES = [131301, 131302, 131303, 131304];
export const RIGHT_FUNDING = 131401;
export const RIGHT_POLICY_RENEWALS = 101205; // cfr.UsersBL.vb : that menu entry is provided when user has PolicyRenew!
export const RIGHT_FEEDBACK_PROMPT = 111008; // cfr.UsersBL.vb : that menu entry is provided when user has ClaimReview!
export const RIGHT_EMAILSETTING = 131304;

export const STRATEGY_INSERT = "INSERT";
export const STRATEGY_INSERT_UPDATE = "INSERT_UPDATE";
export const STRATEGY_UPDATE = "UPDATE";
export const STRATEGY_INSERT_UPDATE_DELETE = "INSERT_UPDATE_DELETE";
